var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicessquaresamjinMultisolid = function SvgIcondevicessquaresamjinMultisolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/icon.devices.square.samjin_multi.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/icon.devices.square.samjin_multi.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1, 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,0.5 C54.9902482,0.5 64.4823403,2.77056772 70.0344659,7.53970122 C76.337221,12.9536063 77.5,21.5662402 77.5,33.5 C77.5,45.4337598 76.337221,54.0463937 70.0344659,59.4602988 C64.4823403,64.2294323 54.9902482,66.5 39,66.5 C23.0097518,66.5 13.5176597,64.2294323 7.96553413,59.4602988 C1.66277898,54.0463937 0.5,45.4337598 0.5,33.5 L0.500924164,32.9251514 C0.538846142,21.2892454 1.76443632,12.8662852 7.96553413,7.53970122 C13.5176597,2.77056772 23.0097518,0.5 39,0.5 Z",
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.5,
    x: 13.25,
    y: 18.25,
    width: 51.5,
    height: 4.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 20.5,
    x2: 75,
    y2: 20.5,
    id: "Line",
    stroke: "#979797",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicessquaresamjinMultisolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.square.samjin_multi.solid.474df25543cdde2835c535cce04f03a5.svg";